import { z } from 'zod';
import { isoDateStringSchema, uuidSchema } from './common';

export const candidateSourceSchema = z.enum([
  'mail',
  'tracking',
  'calendar',
  'habit',
  'project',
  'manual',
  'todo',
]);
export type CandidateSource = z.infer<typeof candidateSourceSchema>;

export const candidatePrioritySchema = z.enum(['low', 'normal', 'high']);
export type CandidatePriority = z.infer<typeof candidatePrioritySchema>;

export const dayPlanItemSchema = z.object({
  candidateId: uuidSchema,
  source: candidateSourceSchema,
  title: z.string(),
  priority: candidatePrioritySchema,
  earliestAt: isoDateStringSchema.nullable(),
  latestAt: isoDateStringSchema.nullable(),
  estDurationMin: z.number().int().nullable(),
  plannedSlot: isoDateStringSchema,
});
export type DayPlanItem = z.infer<typeof dayPlanItemSchema>;

export const dayPlanEventSchema = z.object({
  id: z.string(),
  title: z.string(),
  startsAt: isoDateStringSchema,
  endsAt: isoDateStringSchema,
  allDay: z.boolean(),
  location: z.string().nullable(),
});
export type DayPlanEvent = z.infer<typeof dayPlanEventSchema>;

export const dayPlanDtoSchema = z.object({
  date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  items: z.array(dayPlanItemSchema),
  events: z.array(dayPlanEventSchema),
});
export type DayPlanDto = z.infer<typeof dayPlanDtoSchema>;
